var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('router-view'),_c('DebugDialog'),_c('dialogs-wrapper',{attrs:{"transition-name":"fade"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }